<template>
    <v-container fluid>
        <v-data-table dense :items="counterparts.items" :headers="counterparts.headers" :loading="counterparts.loading"
            :hide-default-header="hideHeader" hide-default-footer disable-pagination disable-filtering disable-sort
            :items-per-page="itemsPerPage" item-key="id" loading-text="Загрузка данных..." no-data-text="Нет данных..."
            no-results-text="Совпадений не найдено..." class="styled-table" mobile-breakpoint="0">

            <!-- Main content column -->
            <template v-slot:[`item.name`]="{ item }">
                {{ item.name }}
            </template>

            <!-- Actions column -->
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-space-between">
                    <!-- ПЕРВАЯ КНОПКА: Реквизиты -->
                    <div class="d-flex align-center mr-4">
                        <v-tooltip v-if="canEdit" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <div class="d-flex align-center" style="cursor: pointer" v-bind="attrs" v-on="on"
                                    @click.stop="editCounterpartDetails(item)">
                                    <v-icon color="primary">mdi-pencil</v-icon>
                                    <span class="ml-1">Реквизиты</span>
                                </div>
                            </template>
                            <span>Изменить реквизиты</span>
                        </v-tooltip>
                    </div>

                    <!-- ВТОРАЯ КНОПКА: Биллинг -->
                    <div class="d-flex align-center mr-4">
                        <v-tooltip v-if="canEdit" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <div class="d-flex align-center" style="cursor: pointer" v-bind="attrs" v-on="on"
                                    @click.stop="goToCounterpartBillingCalculation(item)">
                                    <v-icon color="primary">mdi-pencil</v-icon>
                                    <span class="ml-1">Биллинг</span>
                                </div>
                            </template>
                            <span>Изменить настройки биллинга</span>
                        </v-tooltip>
                    </div>
                </div>
            </template>
        </v-data-table>

        <!-- Add button (if needed) -->
        <v-sheet height="64" />
        <v-btn v-if="canAdd" bottom right color="primary" dark fab fixed to="/settings/cargoTypes/add">
            <v-icon class="white--text">
                mdi-plus
            </v-icon>
        </v-btn>
    </v-container>
</template>

<script>
import router from '../../router';

export default {
    data() {
        return {
            itemsPerPage: Number.MAX_SAFE_INTEGER,
            loading: false,
            counterparts: {
                loading: true,
                items: [],
                headers: [
                    { text: "Список контрагентов", value: "name", class: "tableHeader tableHeaderText--text" }
                ]
            }
        };
    },

    computed: {
        hideHeader() {
            return this.$vuetify?.breakpoint.xsOnly || false;
        },

        // Permission checks - adjust based on your roles
        canAdd() {
            return this.$store.state.auth.user.role === "Управляющий" || this.$store.state.auth.user.role === "Администратор";
        },

        canDelete() {
            return this.$store.state.auth.user.role === "Управляющий" || this.$store.state.auth.user.role === "Администратор";
        },

        canEdit() {
            return this.$store.state.auth.user.role === "Управляющий" || this.$store.state.auth.user.role === "Администратор";
        },

        canViewDetails() {
            // Everyone can view details
            return true;
        }
    },

    async created() {
        await this.init();

        // Add actions column if user has permissions
        if (this.canEdit || this.canDelete || this.canViewDetails) {
            this.counterparts.headers.push({
                text: "",
                value: "actions",
                sortable: false,
                width: "120px",
                class: "tableHeader tableHeaderText--text",
                align: "center"
            });
        }

        // Set up SignalR/WebSocket listeners if needed
        // this.$signals.on("CounterpartNotify", this.onCounterpartNotify);
        // this.$signals.on("Counterpart_Delete", this.onCounterpartDelete);
        // this.$signals.on("Counterpart_Insert", this.onCounterpartInsert);
        // this.$signals.on("Counterpart_Update", this.onCounterpartUpdate);
    },

    beforeDestroy() {
        // Clean up SignalR/WebSocket listeners if needed
        // this.$signals.off("CounterpartNotify", this.onCounterpartNotify);
        // this.$signals.off("Counterpart_Delete", this.onCounterpartDelete);
        // this.$signals.off("Counterpart_Insert", this.onCounterpartInsert);
        // this.$signals.off("Counterpart_Update", this.onCounterpartUpdate);
    },

    methods: {
        async init() {
            try {
                this.counterparts.loading = true;
                const response = await this.axios.get('/cargotypes');
                this.counterparts.items = response.data;
            } catch (error) {
                console.error('Ошибка загрузки контрагентов:', error);
                this.counterparts.items = [];
                // Show error to user if needed
                // this.$router.push(`/error?message=Ошибка при загрузке контрагентов&&error=${error}`);
            } finally {
                this.counterparts.loading = false;
            }
        },

        // SignalR/WebSocket handlers (if needed)
        // onCounterpartNotify(message) {
        //     this.$notify("info", message);
        // },

        // onCounterpartDelete(id) {
        //     this.deleteItem(id);
        // },

        // onCounterpartInsert(id) {
        //     this.axios.get(`/counterparts/get/${id}`).then((response) => {
        //         this.counterparts.items.push(response.data);
        //         this.sort();
        //     });
        // },

        // onCounterpartUpdate(id) {
        //     this.axios.get(`/counterparts/get/${id}`).then((response) => {
        //         this.counterparts.items = this.counterparts.items.map((x) => 
        //             x.id === response.data.id ? response.data : x
        //         );
        //     });
        // },

        // Helper method to delete item from array
        deleteItem(itemID) {
            const index = this.counterparts.items.findIndex((el) => el.id === itemID);
            if (index !== -1) this.counterparts.items.splice(index, 1);
        },

        // Sort method if needed
        sort() {
            this.counterparts.items.sort(function (a, b) {
                // Sort by name alphabetically
                return a.name.localeCompare(b.name);
            });
        },

        // Action methods
        editCounterpartDetails(counterpart) {
            router.push(`/settings/cargoTypes/editDetails/${counterpart.id}`);
        },

        goToCounterpartBillingCalculation(counterpart) {
            router.push(`/settings/cargoTypes/BillingParameters/${counterpart.id}`);
        },

        async deleteCounterpart(counterpart) {
            // Confirm deletion
            if (!(await this.$messageBox(
                `Удалить контрагента <span class="accent--text">${counterpart.name}</span>?`
            ))) {
                return;
            }

            this.loading = true;
            try {
                await this.axios.delete(`/cargotypes/${counterpart.id}`);
                // Remove from local array
                this.deleteItem(counterpart.id);
                // Notify others via SignalR if needed
                // this.$signals.invoke("Counterpart_Delete", counterpart.id);
                // Show success message
                this.$notify("success", `Контрагент ${counterpart.name} удален`);
            } catch (error) {
                console.error('Ошибка удаления контрагента:', error);
                this.$notify("error", "Не удалось удалить контрагента");
            } finally {
                this.loading = false;
            }
        },

        viewDetails(counterpart) {
            // Navigate to details page or open dialog
            // this.$router.push(`/counterpart/details/${counterpart.id}`);
            // Or emit event to parent
            this.$emit('view-details', counterpart);
        },

        // Optional: Handle row click (if you want to keep this functionality)
        itemSelected(item) {
            this.$emit('item-selected', item);
        }
    }
};
</script>